import { driver } from "driver.js";
import "driver.js/dist/driver.css";

export function startTourCrearEvento(navigate, uid) {
  const profilePath = `/perfil/${uid}`;
  if (window.location.pathname === profilePath) {
    setTimeout(() => startCrearEventoFase1(), 400);
  } else {
    sessionStorage.setItem("aw_pending_tour", "crear-evento-fase1");
    navigate(profilePath);
  }
}

export function startCrearEventoFase1() {
  let tabClickHandler = null;
  let gridClickHandler = null;

  const cleanupTabListener = () => {
    const btn = document.querySelector('[data-tour-id="tab-empresas"]');
    if (btn && tabClickHandler) {
      btn.removeEventListener("click", tabClickHandler);
      tabClickHandler = null;
    }
  };

  const cleanupGridListener = () => {
    const grid = document.querySelector('[data-tour-id="empresas-grid"]');
    if (grid && gridClickHandler) {
      grid.removeEventListener("click", gridClickHandler);
      gridClickHandler = null;
    }
  };

  const driverObj = driver({
    showProgress: true,
    nextBtnText: "Siguiente →",
    prevBtnText: "← Anterior",
    doneBtnText: "¡Listo!",
    progressText: "{{current}} de {{total}}",
    allowClose: false,
    onDestroyStarted: () => {
      cleanupTabListener();
      cleanupGridListener();
      driverObj.destroy();
    },
    steps: [
      {
        element: '[data-tour-id="tab-empresas"]',
        popover: {
          title: "Pestaña Empresas",
          description: "Haz clic en la pestaña \"Empresas\" para ver tus empresas y seleccionar en cuál quieres crear el evento.",
          side: "bottom",
          align: "start",
          showButtons: ["close"],
        },
        onHighlightStarted: () => {
          const btn = document.querySelector('[data-tour-id="tab-empresas"]');
          if (!btn) return;
          tabClickHandler = () => {
            cleanupTabListener();
            setTimeout(() => driverObj.moveNext(), 500);
          };
          btn.addEventListener("click", tabClickHandler);
        },
        onDeselected: () => { cleanupTabListener(); },
      },
      {
        element: '[data-tour-id="empresas-grid"]',
        popover: {
          title: "Selecciona tu Empresa",
          description: "Haz clic en la empresa donde quieres publicar tu nuevo evento.",
          side: "top",
          align: "start",
          showButtons: ["close"],
        },
        onHighlightStarted: () => {
          const grid = document.querySelector('[data-tour-id="empresas-grid"]');
          if (!grid) return;
          gridClickHandler = (e) => {
            const card = e.target.closest("a, button, [role='link']");
            if (!card) return;
            cleanupGridListener();
            sessionStorage.setItem("aw_pending_tour", "crear-evento-fase2");
            driverObj.destroy();
          };
          grid.addEventListener("click", gridClickHandler);
        },
        onDeselected: () => { cleanupGridListener(); },
      },
    ],
  });

  driverObj.drive();
}

export function startCrearEventoFase2() {
  let cardClickHandler = null;
  let submitClickHandler = null;

  const cleanupCardListener = () => {
    const card = document.querySelector('[data-tour-id="crear-evento-card"]');
    if (card && cardClickHandler) {
      card.removeEventListener("click", cardClickHandler);
      cardClickHandler = null;
    }
  };

  const cleanupSubmitListener = () => {
    const btn = document.querySelector('[data-tour-id="btn-crear-nuevo-evento"]');
    if (btn && submitClickHandler) {
      btn.removeEventListener("click", submitClickHandler);
      submitClickHandler = null;
    }
  };

  const driverObj = driver({
    showProgress: true,
    nextBtnText: "Siguiente →",
    prevBtnText: "← Anterior",
    doneBtnText: "¡Listo!",
    progressText: "{{current}} de {{total}}",
    allowClose: false,
    onDestroyStarted: () => {
      cleanupCardListener();
      cleanupSubmitListener();
      driverObj.destroy();
    },
    steps: [
      {
        element: '[data-tour-id="crear-evento-card"]',
        popover: {
          title: "Crear Evento",
          description: "Haz clic en esta tarjeta para abrir el formulario de creación de evento.",
          side: "right",
          align: "start",
          showButtons: ["close"],
        },
        onHighlightStarted: () => {
          const card = document.querySelector('[data-tour-id="crear-evento-card"]');
          if (!card) return;
          cardClickHandler = () => {
            cleanupCardListener();
            setTimeout(() => driverObj.moveNext(), 600);
          };
          card.addEventListener("click", cardClickHandler);
        },
        onDeselected: () => { cleanupCardListener(); },
      },
      {
        element: "#nombre",
        popover: {
          title: "Nombre del Evento",
          description: "Escribe el nombre de tu evento. Este será el título principal que verán los asistentes.",
          side: "bottom",
          align: "start",
          showButtons: ["next", "close"],
        },
      },
      {
        element: "#aforo",
        popover: {
          title: "Aforo",
          description: "Ingresa la capacidad máxima del lugar. Este dato no podrá ser modificado después, así que asegúrate de ingresar el número correcto.",
          side: "bottom",
          align: "start",
          showButtons: ["next", "close"],
        },
      },
      {
        element: '[data-tour-id="crear-evento-embajadores"]',
        popover: {
          title: "Configuración de Embajadores",
          description: "Elige si utilizarás embajadores para vender tickets. Si seleccionas alguna opción con embajadores, también deberás elegir el porcentaje de comisión. Esta comisión tampoco podrá modificarse después.",
          side: "top",
          align: "start",
          showButtons: ["next", "close"],
        },
      },
      {
        element: "#acceptCreation",
        popover: {
          title: "Términos y Condiciones",
          description: "Marca esta casilla para aceptar los términos y condiciones. Puedes leerlos haciendo clic en el enlace.",
          side: "top",
          align: "start",
          showButtons: ["next", "close"],
        },
      },
      {
        element: '[data-tour-id="btn-crear-nuevo-evento"]',
        popover: {
          title: "Crear Nuevo Evento",
          description: "Cuando hayas rellenado todos los campos, haz clic aquí para crear tu evento. Serás redirigido a la página de configuración del evento.",
          side: "top",
          align: "end",
          showButtons: ["close"],
        },
        onHighlightStarted: () => {
          const btn = document.querySelector('[data-tour-id="btn-crear-nuevo-evento"]');
          if (!btn) return;
          submitClickHandler = () => {
            cleanupSubmitListener();
            sessionStorage.setItem("aw_pending_tour", "crear-evento-fase3");
            driverObj.destroy();
          };
          btn.addEventListener("click", submitClickHandler);
        },
        onDeselected: () => { cleanupSubmitListener(); },
      },
    ],
  });

  driverObj.drive();
}

export function startCrearEventoFase3() {
  let editarClickHandler = null;
  let ubicacionEditarClickHandler = null;
  let agregarTicketClickHandler = null;
  let ticketToggleClickHandler = null;
  let definirPrecioClickHandler = null;

  const cleanupEditarListener = () => {
    const btn = document.querySelector('[data-tour-id="card-evento-editar"]');
    if (btn && editarClickHandler) {
      btn.removeEventListener("click", editarClickHandler);
      editarClickHandler = null;
    }
  };

  const cleanupUbicacionEditarListener = () => {
    const btn = document.querySelector('[data-tour-id="ubicacion-editar"]');
    if (btn && ubicacionEditarClickHandler) {
      btn.removeEventListener("click", ubicacionEditarClickHandler);
      ubicacionEditarClickHandler = null;
    }
  };

  const cleanupAgregarTicketListener = () => {
    const btn = document.querySelector('[data-tour-id="btn-agregar-ticket"]');
    if (btn && agregarTicketClickHandler) {
      btn.removeEventListener("click", agregarTicketClickHandler);
      agregarTicketClickHandler = null;
    }
  };

  const cleanupTicketToggleListener = () => {
    const btn = document.querySelector('[data-tour-id="ticket-toggle"]');
    if (btn && ticketToggleClickHandler) {
      btn.removeEventListener("click", ticketToggleClickHandler);
      ticketToggleClickHandler = null;
    }
  };

  const cleanupDefinirPrecioListener = () => {
    const btn = document.querySelector('[data-tour-id="btn-definir-precio"]');
    if (btn && definirPrecioClickHandler) {
      btn.removeEventListener("click", definirPrecioClickHandler);
      definirPrecioClickHandler = null;
    }
  };

  const driverObj = driver({
    showProgress: true,
    nextBtnText: "Siguiente →",
    prevBtnText: "← Anterior",
    doneBtnText: "¡Listo!",
    progressText: "{{current}} de {{total}}",
    allowClose: false,
    onDestroyStarted: () => {
      cleanupEditarListener();
      cleanupUbicacionEditarListener();
      cleanupAgregarTicketListener();
      cleanupTicketToggleListener();
      cleanupDefinirPrecioListener();
      driverObj.destroy();
    },
    steps: [
      // === SECCIÓN 1: CardEvento ===
      {
        element: '[data-tour-id="card-evento-editar"]',
        popover: {
          title: "Editar Información del Evento",
          description: "Haz clic en \"Editar\" para configurar los detalles principales de tu evento: imagen, título, zona horaria, fecha y hora.",
          side: "bottom",
          align: "end",
          showButtons: ["close"],
        },
        onHighlightStarted: () => {
          const btn = document.querySelector('[data-tour-id="card-evento-editar"]');
          if (!btn) return;
          editarClickHandler = () => {
            cleanupEditarListener();
            setTimeout(() => driverObj.moveNext(), 500);
          };
          btn.addEventListener("click", editarClickHandler);
        },
        onDeselected: () => { cleanupEditarListener(); },
      },
      {
        popover: {
          title: "Imagen y Título del Evento",
          description: "Sube una imagen atractiva para tu evento y escribe el título que verán los asistentes.",
          showButtons: ["next", "close"],
        },
      },
      {
        popover: {
          title: "Zona Horaria y Fecha",
          description: "Selecciona la zona horaria del evento, la fecha de inicio y la hora. También configura la duración (fecha y hora de finalización).",
          showButtons: ["next", "close"],
        },
      },
      {
        popover: {
          title: "Subtítulo en Descuento",
          description: "Si quieres mostrar un mensaje especial en la tarjeta del evento (como \"Ticket en Descuento\"), activa esta opción y escribe el texto. Cuando hayas terminado, pulsa \"Guardar Cambios\".",
          showButtons: ["next", "close"],
        },
      },
      // === SECCIÓN 2: CardAmbassadors ===
      {
        element: '[data-tour-id="card-embajadores-config"]',
        popover: {
          title: "Configuración de Embajadores",
          description: "Aquí puedes actualizar la configuración de embajadores para este evento o ver quiénes están participando.",
          side: "top",
          align: "start",
          showButtons: ["next", "close"],
        },
      },
      {
        element: '[data-tour-id="card-descripcion"]',
        popover: {
          title: "Descripción del Evento",
          description: "Escribe una descripción detallada de tu evento. Explica qué pasará, quiénes son los artistas, y cualquier información relevante para los asistentes.",
          side: "top",
          align: "start",
          showButtons: ["next", "close"],
        },
      },
      {
        element: '[data-tour-id="card-ubicacion"]',
        popover: {
          title: "Ubicación del Evento",
          description: "Haz clic en \"Editar\" para configurar la dirección del evento. Puedes ingresar la dirección en texto o pegar un enlace de Google Maps.",
          side: "top",
          align: "start",
          showButtons: ["close"],
        },
        onHighlightStarted: () => {
          setTimeout(() => {
            const btn = document.querySelector('[data-tour-id="ubicacion-editar"]');
            if (!btn) return;
            ubicacionEditarClickHandler = () => {
              cleanupUbicacionEditarListener();
              setTimeout(() => driverObj.moveNext(), 500);
            };
            btn.addEventListener("click", ubicacionEditarClickHandler);
          }, 100);
        },
        onDeselected: () => { cleanupUbicacionEditarListener(); },
      },
      {
        element: '[data-tour-id="card-ubicacion"]',
        popover: {
          title: "Configurar Ubicación",
          description: "Puedes escribir la dirección directamente en el campo de texto, o pegar el enlace de Google Maps del lugar. Cuando termines, pulsa Guardar o Cancelar.",
          side: "top",
          align: "start",
          showButtons: ["next", "close"],
        },
      },
      {
        element: '[data-tour-id="card-categorias"]',
        popover: {
          title: "Categoría del Evento",
          description: "Selecciona la categoría de tu evento. Por ahora solo puedes elegir una categoría, que ayudará a los usuarios a encontrarlo en AppWhoop.",
          side: "top",
          align: "start",
          showButtons: ["next", "close"],
        },
      },
      // === SECCIÓN 3: CardTickets ===
      {
        element: '[data-tour-id="btn-agregar-ticket"]',
        popover: {
          title: "Agregar Tipo de Ticket",
          description: "Haz clic aquí para agregar tu primer tipo de ticket. Puedes tener múltiples tipos (General, VIP, etc.).",
          side: "top",
          align: "center",
          showButtons: ["close"],
        },
        onHighlightStarted: () => {
          const btn = document.querySelector('[data-tour-id="btn-agregar-ticket"]');
          if (!btn) return;
          agregarTicketClickHandler = () => {
            cleanupAgregarTicketListener();
            setTimeout(() => driverObj.moveNext(), 500);
          };
          btn.addEventListener("click", agregarTicketClickHandler);
        },
        onDeselected: () => { cleanupAgregarTicketListener(); },
      },
      {
        element: '[data-tour-id="ticket-toggle"]',
        popover: {
          title: "Abrir Configuración del Ticket",
          description: "Haz clic en la flecha para abrir la configuración detallada del tipo de ticket.",
          side: "bottom",
          align: "start",
          showButtons: ["close"],
        },
        onHighlightStarted: () => {
          setTimeout(() => {
            const btn = document.querySelector('[data-tour-id="ticket-toggle"]');
            if (!btn) return;
            ticketToggleClickHandler = () => {
              cleanupTicketToggleListener();
              setTimeout(() => driverObj.moveNext(), 400);
            };
            btn.addEventListener("click", ticketToggleClickHandler);
          }, 200);
        },
        onDeselected: () => { cleanupTicketToggleListener(); },
      },
      {
        popover: {
          title: "Nombre del Tipo de Ticket",
          description: "Escribe el nombre de este tipo de ticket, por ejemplo \"General\", \"VIP\", \"Mesa Golden\", etc.",
          showButtons: ["next", "close"],
        },
      },
      {
        popover: {
          title: "Cantidad y Límite por Usuario",
          description: "Define cuántos tickets de este tipo estarán disponibles para la venta, y cuántos puede comprar un mismo usuario.",
          showButtons: ["next", "close"],
        },
      },
      {
        element: '[data-tour-id="btn-definir-precio"]',
        popover: {
          title: "Definir Precio",
          description: "Haz clic aquí para definir el precio del ticket. AppWhoop calculará automáticamente las comisiones y el precio final para el comprador.",
          side: "top",
          align: "start",
          showButtons: ["close"],
        },
        onHighlightStarted: () => {
          setTimeout(() => {
            const btn = document.querySelector('[data-tour-id="btn-definir-precio"]');
            if (!btn) return;
            definirPrecioClickHandler = () => {
              cleanupDefinirPrecioListener();
              driverObj.destroy();
            };
            btn.addEventListener("click", definirPrecioClickHandler);
          }, 200);
        },
        onDeselected: () => { cleanupDefinirPrecioListener(); },
      },
    ],
  });

  driverObj.drive();
}
